import type { UIRouter } from '@wix/tpa-router';

export function configureRouter(router: UIRouter) {
  router.urlService.rules.initial({ state: 'groups.list' });
  router.urlService.rules.otherwise({ state: 'groups.list' });
}
